import React from 'react';
import AniLink from "gatsby-plugin-transition-link/AniLink"

const MobilePrimaryLink = ({ label, link, image, altText, onClickHideMenu, ctaLink}) => {

  // We want to check if we are on the homepage and if the link is the CTA link
  // If so, we don't want to reload the page. Instead scroll to the forms section
  const pathname = window.location.pathname;
  const isHomepage = pathname === '/' || pathname === '';
  const isCTA = link === 'https://www.rula.com/#section-half-and-half';

  if (isCTA && isHomepage) {
    return (
      <AniLink className='primary-link' fade href={ctaLink}><span className='link-wrapper' onClick={onClickHideMenu}>{label}</span></AniLink>
    )
  }


  return (
    <AniLink className='primary-link' fade to={link}><span className='icon-wrapper'>{image && <img src={image} alt={altText} />}</span>{label}</AniLink>
  )
}

export default MobilePrimaryLink;